import { Role } from "~/enums/role";
import { ROUTE_ADMIN_IMPORTS_EMPLOYEES } from "~/constants/routes";

export function isGlobalAdmin(user: { roles?: string[] } | null | undefined): boolean {
  return user?.roles?.includes(Role.Admin) === true;
}

export function isContextFreeEmployeeAdminPage(path: string, user: { roles?: string[] } | null | undefined): boolean {
  return path === ROUTE_ADMIN_IMPORTS_EMPLOYEES && isGlobalAdmin(user);
}
